import { render } from "./QuotesEdit.vue?vue&type=template&id=0db2577a&scoped=true"
import script from "./QuotesEdit.vue?vue&type=script&lang=js"
export * from "./QuotesEdit.vue?vue&type=script&lang=js"

import "./QuotesEdit.vue?vue&type=style&index=0&id=0db2577a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0db2577a"

export default script